import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, MenuItem, Typography } from "@mui/material";
import FormComponent from "../../../components/gernerateForm/FormComponent";
import generateFormSubmissionOnline from "./form-submission/data/form02.data";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonBack,
  ButtonDel,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { FiberManualRecord, FileDownloadOutlined } from "@mui/icons-material";
import {
  alertActive,
  alertError,
  alertSuccess,
  swalConfirm,
} from "../../../components/alert/swal";
import { OnlineLeaveSubmissionApi } from "../../../api/online-leave-submission/online-leave-submission.api";
import { useParams } from "react-router-dom";
import { calculateLeavePeriod } from "../../../utils/calculatePeriod";
import UploadFile from "../../../components/upload/UploadFile";
import CustomStatus from "../../../components/chip/CustomStatus";
import {
  handleColorStatusUtil,
  handleTextStatusUtil,
} from "../../../utils/statusLeaveRequest";
import moment from "moment";
import generateForm01 from "./form-submission/data/form01.data";
import generateForm02 from "./form-submission/data/form02.data";
import generateForm03 from "./form-submission/data/form03.data";
import generateForm04 from "./form-submission/data/form04.data";
import generateForm05 from "./form-submission/data/form05.data";
import generateForm06 from "./form-submission/data/form06.data";
import generateForm07 from "./form-submission/data/form07.data";
import generateForm10 from "./form-submission/data/form10.data";
import generateForm11 from "./form-submission/data/form11.data";
import InputTextField from "../../../components/input/inputTextField";
import InputDatePicker from "../../../components/input/inputDatePicker";
import { leaveTypeApi } from "../../../api/leave-type/leave-type.api";
import FilterSelect from "../../../components/select/filterSelect";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import Form11 from "./form-submission/form/Form11";
import Form10 from "./form-submission/form/Form10";
import Form07 from "./form-submission/form/Form07";
import Form05 from "./form-submission/form/Form05";
import Form04 from "./form-submission/form/Form04";
import Form03 from "./form-submission/form/Form03";
import Form02 from "./form-submission/form/Form02";
import Form01 from "./form-submission/form/Form01";
import Form06 from "./form-submission/form/Form06";
import Form08 from "./form-submission/form/Form08";
import Form09 from "./form-submission/form/Form09";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";
import { getToken } from "../../../utils/app.utils";
import { leaveFormApi } from "../../../api/leave-form/leave-form.api";
import { ReportApi } from "../../../api/report/Report.api";

type Props = {};

interface LeaveType {
  id_leave_type: number;
  id_leave_form: number;
  leave_type_name: string;
  is_accumulate: string;
  id_employee_inspector: number;
  id_employee_approve: number;
  status: string;
  created_id: number;
  created_date: string;
  modified_id: number;
  modified_date: string;
  leave_form: {
    json: string;
  };
}

const OnlineLeaveSubmissionDetail: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const leaveRequestId = id ? parseInt(id) : 0;
  const location = useLocation();
  const pathname = location.pathname;
  const token = getToken();

  const [mainInputValue, setMainInputValue] = useState({
    information: {
      leave_id: 0,
      id_employee: 0,
      employee_no: "",
      title: "",
      first_name: "",
      last_name: "",
      buddhist_name: "",
      leave_type_id: 0,
      leave_form_no: "",
      leave_peroid_date: [],
      leave_status: "",
      quit_date: "",
      leave_day: 0,
      worship: "",
    },
  });
  // console.log(mainInputValue,'mainInputValue')

  const [dataJson, setDataJson] = useState<any>("");
  const [idEmployeeApproveFirst, setIdEmployeeApproveFirst] = useState(0);
  const [idEmployeeApproveSecond, setIdEmployeeApproveSecond] = useState(0);
  const [idEmployeeApproveThird, setIdEmployeeApproveThird] = useState(0);

  const [id_leave_form, set_id_leave_form] = useState<number | null>(null);

  const [commentApprove, setCommentApprove] = useState({
    comment: "",
  });

  const [isCanEdit, setIsCanEdit] = useState(false);
  const [isValidateForm, setIsValidateForm] = useState(false);
  const [isValudateFile, setIsValudateFile] = useState(false);

  const [documentUpload, setDocumentUpload] = useState<any[]>([]);
  const [file, setFile] = useState(null);

  const [dataLeaveType, setDataLeaveType] = useState<LeaveType[]>([]);

  const getLeaveType = async () => {
    const param = { limit: 100 };
    const res = await leaveTypeApi.getAllLeaveType(param);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveType(data.data.items);
    } else {
      setDataLeaveType([]);
    }
  };

  useEffect(() => {
    // No leave id = nothing to fetch, just show a brief loading on mount
    if (!leaveRequestId) {
      dispatch(setLoading());
      setTimeout(() => {
        dispatch(unsetLoading());
      }, 500);
    }
  }, []);

  const getLeaveRequestDetail = async (leave_id: number) => {
    dispatch(setLoading());
    try {
      const res =
        await OnlineLeaveSubmissionApi.getSingleRequestLeaveSubmission(
          leave_id
        );
      const data = res.data;

      if (data.status < 300 && data.data) {
        const { data: leaveData } = data;

        const newDataDetail = leaveData.leave_detail
          ? JSON.parse(leaveData.leave_detail)
          : "";

        const newData = {
          leave_id: leaveData.id_leave,
          id_employee: leaveData.employee.id_employee,
          employee_no: leaveData.employee.employee_no,
          title: leaveData.employee.title,
          first_name: leaveData.employee.first_name,
          last_name: leaveData.employee.last_name,
          buddhist_name: leaveData.employee.buddhist_name,
          leave_type_id: leaveData.id_leave_type,
          leave_form_no: leaveData.leave_type?.id_leave_form
            ? leaveData.leave_type.id_leave_form < 10
              ? "0" + leaveData.leave_type.id_leave_form.toString()
              : leaveData.leave_type.id_leave_form.toString()
            : "",
          leave_peroid_date: [
            moment(leaveData.leave_start_date).format("YYYY-MM-DD"),
            moment(leaveData.leave_end_date).format("YYYY-MM-DD"),
          ],
          quit_date: newDataDetail.main?.quit_date ?? "",
          leave_day: calculateLeavePeriod(
            leaveData.leave_start_date,
            leaveData.leave_end_date
          ),
          leave_status: leaveData.leave_status,
          worship: newDataDetail.main?.worship ?? "",
        };
        set_id_leave_form(leaveData?.leave_type?.id_leave_form ?? null);

        // Update state with the new data
        setMainInputValue({
          information: newData as any,
        });
        setDataJson(newDataDetail ?? {});
        setIdEmployeeApproveFirst(leaveData.leave_approve_first ?? 0);
        setIdEmployeeApproveSecond(leaveData.leave_approve_second ?? 0);
        setIdEmployeeApproveThird(leaveData.leave_approve_third ?? 0);
        setDocumentUpload(leaveData.leave_file);

        // console.log("leaveData.leave_approve_first_comment", leaveData);
        if (
          leaveData.leave_status === "approve third" ||
          leaveData.leave_status === "not approve third"
        ) {
          setCommentApprove({
            comment: leaveData.leave_approve_third_comment,
          });
        } else if (
          leaveData.leave_status === "approve second" ||
          leaveData.leave_status === "not approve second"
        ) {
          setCommentApprove({
            comment: leaveData.leave_approve_second_comment,
          });
        } else if (
          leaveData.leave_status === "approve first" ||
          leaveData.leave_status === "not approve first"
        ) {
          setCommentApprove({
            comment: leaveData.leave_approve_first_comment,
          });
        } else {
          setCommentApprove({
            comment: "",
          });
        }
      } else {
      }
    } catch (error) {
      console.error("Error fetching leave request details:", error);
    } finally {
      dispatch(unsetLoading());
    }
  };
  // console.log(id_leave_form,'l')

  useEffect(() => {
    if (leaveRequestId) {
      getLeaveRequestDetail(leaveRequestId);
    }
  }, [leaveRequestId]);

  useEffect(() => {
    const { leave_peroid_date } = mainInputValue.information;

    if (leave_peroid_date[0] && leave_peroid_date[1]) {
      const leaveDays = calculateLeavePeriod(
        leave_peroid_date[0],
        leave_peroid_date[1]
      );

      setMainInputValue((prevState) => ({
        information: {
          ...prevState.information,
          leave_day: leaveDays,
        },
      }));
    }
  }, [mainInputValue.information.leave_peroid_date]);

  const validateForm = (formData: any, formConfig: any) => {
    const errors: any = {};

    formConfig.forEach((field: any) => {
      if (field.isRequired && formData[field.section][field.name] === "") {
        errors[field.name] = `${field.label} is required`;
      }
    });

    return errors;
  };

  const updateLeaveRequest = async (
    employee_id: number,
    dataBody: any,
    fileUpload: any,
    dataCondition?: any
  ) => {
    const dataJson = JSON.stringify(dataCondition);

    const handleBodyApi = {
      id_leave_type: dataBody.information.leave_type_id,
      leave_start_date:
        dataBody.information.leave_peroid_date.length === 2
          ? new Date(dataBody.information.leave_peroid_date[0]).toDateString()
          : null,
      leave_end_date:
        dataBody.information.leave_peroid_date.length === 2
          ? new Date(dataBody.information.leave_peroid_date[1]).toDateString()
          : null,
      id_employee: dataBody.information.id_employee,
      leave_detail: dataJson,
      leave_approve_first: idEmployeeApproveFirst,
    };

    // Creating FormData instance for file uploads and other data
    const formData: FormData = new FormData();

    // Append other data from handleBodyApi to formData
    Object.entries(handleBodyApi).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // Append files to formData
    fileUpload &&
      fileUpload.forEach((file: any) => {
        formData.append("file", file);
      });

    await OnlineLeaveSubmissionApi.updateRequestLeaveSubmission(
      employee_id,
      formData
    )
      .then((res) => {
        if (res.status < 300) {
          alertSuccess("สำเร็จ", "อัพเดทข้อมูลการลา เรียบร้อยแล้ว", "ตกลง");
          getLeaveRequestDetail(employee_id);
          setIsCanEdit(false);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => {
        console.log("success");
      });
  };

  const handleSubmit = (
    employee_id: number,
    dataBody: any,
    fileUpload: any,
    dataCondition?: any
  ) => {
    if (isCanEdit && employee_id) {
      let errors;

      if (mainInputValue.information.leave_form_no === "01") {
        errors = validateForm(mainInputValue, generateForm01);
      } else if (mainInputValue.information.leave_form_no === "02") {
        errors = validateForm(mainInputValue, generateForm02);
      } else if (mainInputValue.information.leave_form_no === "03") {
        errors = validateForm(mainInputValue, generateForm03);
      } else if (mainInputValue.information.leave_form_no === "04") {
        errors = validateForm(mainInputValue, generateForm04);
      } else if (mainInputValue.information.leave_form_no === "05") {
        errors = validateForm(mainInputValue, generateForm05);
      } else if (mainInputValue.information.leave_form_no === "06") {
        errors = validateForm(mainInputValue, generateForm06);
      } else if (mainInputValue.information.leave_form_no === "07") {
        errors = validateForm(mainInputValue, generateForm07);
      } else if (mainInputValue.information.leave_form_no === "08") {
        errors = validateForm(mainInputValue, generateForm03);
      } else if (mainInputValue.information.leave_form_no === "09") {
        errors = validateForm(mainInputValue, generateForm03);
      } else if (mainInputValue.information.leave_form_no === "10") {
        errors = validateForm(mainInputValue, generateForm10);
      } else if (mainInputValue.information.leave_form_no === "11") {
        errors = validateForm(mainInputValue, generateForm11);
      }

      // if (!fileUpload) {
      //   setIsValudateFile(true);
      //   return setIsValidateForm(true);
      // }

      if (Object.keys(errors).length > 0) {
        setIsValidateForm(true);
      } else {
        setIsValidateForm(false);
        setIsValudateFile(false);
        updateLeaveRequest(employee_id, dataBody, fileUpload, dataCondition);
      }
    }
  };

  const handleDeleteLeaveRequest = async () => {
    if (id) {
      alertActive(
        "ลบการลา",
        "ท่านต้องการลบการลา ใช่หรือไม่",
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await OnlineLeaveSubmissionApi.deleteRequestLeaveSubmission(+id)
            .then((res) => {
              if (res.status < 300) {
                alertSuccess("ลบการลาเรียบร้อย", undefined, undefined, () => {
                  navigate(routeName.cms.OnlineLeaveSubmission);
                });
              }
            })
            .catch(() => {
              alertError("ลบการลา ไม่สำเร็จ");
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const handleSendLeaveRequest = async () => {
    if (id) {
      alertActive(
        "ยืนยันการลา",
        "ท่านต้องการส่งลา ใช่หรือไม่",
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());

          const formData: FormData = new FormData();
          // formData.append("file", file ? file[0] : null);
          formData.append("leave_status", "wait");

          await OnlineLeaveSubmissionApi.updateRequestLeaveSubmission(
            +id,
            formData
          )
            .then((res) => {
              if (res.status < 300) {
                alertSuccess("ส่งใบลา เรียบร้อย", undefined, undefined, () => {
                  getLeaveRequestDetail(+id);
                });
              }
            })
            .catch(() => {
              alertError("ส่งใบลา ไม่สำเร็จ");
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };


  const [file_pdf, set_file_pdf] = useState<Blob | null>(null);

  const handleDownloadFileExport = async (id_leave: number) => {
    dispatch(setLoading());
    await ReportApi.reportLeaveManagementById(id_leave).then((res) => {
      if (res.status < 300) {
        const response = res.data;
        const blob_file = new Blob([response], { type: "application/pdf" });
        set_file_pdf(blob_file);
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      dispatch(unsetLoading());
    })
  }


  // const handleDeleteFile = async () => {
  //   console.log("delete file");
  // };

  const handleDownloadFile = async (
    leave_id: number,
    id_leave_file: number,
    export_type: string
  ) => {
    let query: any = {
      type: export_type,
    };
    dispatch(setLoading());
    await OnlineLeaveSubmissionApi.GetFileByIdLeaveFile(query, id_leave_file)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `attachment-leave-request-${new Date().getTime()}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  const handleChangePeriodLeave = (value: any) => {
    setMainInputValue({
      information: {
        ...mainInputValue.information,
        leave_peroid_date: value,
      },
    });
  };

  const handleClearPeriodLeave = () => {
    setMainInputValue({
      information: {
        ...mainInputValue.information,
        leave_peroid_date: [],
      },
    });
  };


  useEffect(() => {
    if (leaveRequestId && mainInputValue.information.leave_form_no) {
      handleDownloadFileExport(+leaveRequestId
      )
    }
  }, [leaveRequestId, token, mainInputValue.information.leave_form_no])
//   console.log(mainInputValue.information.leave_form_no,'frmno')
// console.log(mainInputValue.information.leave_status,'st')
  useEffect(() => {
    getLeaveType();
  }, []);

  return (
    <div className="h-auto">
      <NavigateListCustom
        navigateData={[
          {
            name: t(
              "ONLINE_LEAVE_SUBMISSION.COMMON.BREADCRUMB.ONLINE_LEAVE_SUBMISSION_SYSTEM"
            ),
            key: "1",
            pathName: routeName.cms.OnlineLeaveSubmission,
          },
          {
            name: t(
              "ONLINE_LEAVE_SUBMISSION.COMMON.BREADCRUMB.ONLINE_LEAVE_SUBMISSION"
            ),
            key: "2",
            pathName: pathname
          },
        ]}
      />
      {/* header */}
      <section className="my-4">
        <Typography variant="h3">
          {t("ONLINE_LEAVE_SUBMISSION.TOPIC.SUB_ONLINE_LEAVE_SUBMISSION")}
        </Typography>
        <CustomStatus
          label={handleTextStatusUtil(mainInputValue.information.leave_status)}
          type="outlined"
          color={handleColorStatusUtil(mainInputValue.information.leave_status)}
          icon={<FiberManualRecord />}
          width="250px"
        />
      </section>

      <section className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        {commentApprove.comment ? (
          <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
            <InputTextField
              heading={"ความคิดเห็นผู้บังคับบัญชา"}
              value={commentApprove.comment ?? ""}
              disabled={false}
              row={3}
              maxRows={5}
              disablePaddingMultiline
              multiline
              inputHeight={"auto"}
              borderColor={
                handleColorStatusUtil(
                  mainInputValue.information.leave_status
                ) === "error"
                  ? "red"
                  : "green"
              }
            />
          </article>
        ) : null}

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-6 sm:col-span-12">
          <InputTextField
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.PREFIX_LABEL")}
            value={mainInputValue.information.title ?? ""}
            disabled={true}
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-4 md:col-span-6 sm:col-span-12">
          <InputTextField
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.FIRST_NAME_LABEL")}
            value={mainInputValue.information.first_name ?? ""}
            disabled={true}
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
          <InputTextField
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.LAST_NAME_LABEL")}
            value={mainInputValue.information.last_name ?? ""}
            disabled={true}
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
          <InputTextField
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.NICKNAME_LABEL")}
            value={mainInputValue.information.buddhist_name ?? ""}
            disabled={true}
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
          <FilterSelect
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.LEAVE_TYPE_LABEL")}
            value={mainInputValue.information.leave_type_id}
            disabled
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const selectedOption = dataLeaveType.find(
                (option: any) =>
                  option.id_leave_type === parseInt(e.target.value)
              );
              if (selectedOption) {
                setIdEmployeeApproveSecond(
                  selectedOption.id_employee_inspector
                );
                setIdEmployeeApproveThird(selectedOption.id_employee_approve);
                setMainInputValue({
                  information: {
                    ...mainInputValue.information,
                    leave_type_id: selectedOption?.id_leave_type || 0,
                    leave_form_no: selectedOption?.leave_form.json || "",
                    leave_peroid_date: [],
                    leave_day: 0,
                    worship: "",
                  },
                });
                setDataJson("");
              }
            }}
            options={dataLeaveType.map((option: any) => (
              <MenuItem value={option.id_leave_type} key={option.id_leave_type}>
                {option.leave_type_name}
              </MenuItem>
            ))}
            labelId={""}
            selectId={""}
          />
        </article>

        {mainInputValue.information.leave_type_id &&
          mainInputValue.information.leave_form_no ? (
          <>
            {mainInputValue.information.leave_form_no === "01" ||
              mainInputValue.information.leave_form_no === "02" ||
              mainInputValue.information.leave_form_no === "03" ||
              mainInputValue.information.leave_form_no === "04" ||
              mainInputValue.information.leave_form_no === "05" ||
              mainInputValue.information.leave_form_no === "06" ? (
              <>
                <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                  <InputNewRangePicker
                    heading={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.PEROID_LEAVE_START_DATE_LABEL"
                    )}
                    value={mainInputValue.information.leave_peroid_date}
                    onchange={handleChangePeriodLeave}
                    onClear={handleClearPeriodLeave}
                    disabled={!isCanEdit}
                    allowClear
                  />
                </article>

                <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                  <InputTextField
                    heading={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.LEAVE_AMOUNT_DATE_LABEL"
                    )}
                    value={mainInputValue.information.leave_day ?? ""}
                    disabled={true}
                  />
                </article>

                <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                  <InputTextField
                    heading={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_LABEL"
                    )}
                    placeholder={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_PLACEHOLDER"
                    )}
                    value={mainInputValue.information.worship ?? ""}
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setMainInputValue({
                        information: {
                          ...mainInputValue.information,
                          worship: e.target.value,
                        },
                      })
                    }
                    disabled={!isCanEdit}
                  />
                </article>
              </>
            ) : null}

            {mainInputValue.information.leave_form_no === "07" ? (
              <>
                <article className="w-full col-span-12 lg:col-span-3 md:col-span-12 sm:col-span-12">
                  <InputDatePicker
                    heading={"ขอลาออกตั้งแต่วันที่"}
                    value={mainInputValue.information.quit_date ?? ""}
                    onChange={(e: any) =>
                      setMainInputValue({
                        information: {
                          ...mainInputValue.information,
                          quit_date: moment(e).format("YYYY-MM-DD"),
                        },
                      })
                    }
                  />
                </article>
              </>
            ) : null}

            {mainInputValue.information.leave_form_no === "08" ||
              mainInputValue.information.leave_form_no === "09" ||
              mainInputValue.information.leave_form_no === "10" ||
              mainInputValue.information.leave_form_no === "11" ? (
              <>
                <article className="w-full col-span-12 lg:col-span-9 md:col-span-12 sm:col-span-12">
                  <InputTextField
                    heading={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_LABEL"
                    )}
                    placeholder={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_PLACEHOLDER"
                    )}
                    value={mainInputValue.information.worship ?? ""}
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setMainInputValue({
                        information: {
                          ...mainInputValue.information,
                          worship: e.target.value,
                        },
                      })
                    }
                  />
                </article>
              </>
            ) : null}
          </>
        ) : null}
      </section>

      <section className="w-full col-span-12 lg:col-span-12 md:col-span-6 sm:col-span-12 mt-4">
        {mainInputValue.information.leave_type_id &&
          mainInputValue.information.leave_form_no ? (
          <>
            {mainInputValue.information.leave_form_no === "01" ? (
              <>
                <Form01
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "02" ? (
              <>
                <Form02
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "03" ? (
              <>
                <Form03
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "04" ? (
              <>
                <Form04
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "05" ? (
              <>
                <Form05
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "06" ? (
              <>
                <Form06
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "07" ? (
              <>
                <Form07
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "08" ? (
              <>
                <Form08
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "09" ? (
              <>
                <Form09
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "10" ? (
              <>
                <Form10
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "11" ? (
              <>
                <Form11
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                  isCanEdit={isCanEdit}
                />
              </>
            ) : null}
          </>
        ) : null}
      </section>

      <section className="w-full my-2 gap-4">
        <UploadFile
          onDrop={(file) => {
            setFile(file);
          }}
          file={file}
          onDeleteFile={() => {
            setFile(null);
          }}
          noClick={!isCanEdit}
        />

        {documentUpload && documentUpload.length > 0
          ? documentUpload.map((item: any, index) => {
            return (
              <div
                key={index + 1}
                style={{
                  marginTop: 8,
                }}
              >
                <UploadFile
                  heading="ไฟล์แนบ"
                  fileAttachmentId={item.id_leave_file}
                  fileAttachmentName={item.file_name}
                  noClick={item.id_leave_file ?? true}
                  onDeleteFile={() => { }}
                  // helperText={item?.id_leave_file}
                  onDrop={() => { }}
                  // file={item?.file_path}
                  formatText={t("FILE_UPLOAD.FILE_SIZE")}
                  disableDeleteFileId={!isCanEdit}
                  onDeleteFileId={() => {
                    // handleDeleteFile(item.id_leave, item.id_leave_file);
                  }}
                  hiddenDownloadFile={isCanEdit}
                  {...(!isCanEdit
                    ? {
                      onDownloadFile: () => {
                        handleDownloadFile(
                          item.id_leave,
                          item.id_leave_file,
                          "pdf"
                        );
                      },
                    }
                    : {})}
                />
              </div>
            );
          })
          : null}
      </section>

      {(mainInputValue.information.leave_status === "approve third" ||
        (mainInputValue.information.leave_status === "not approve third" &&
          ["01", "02", "03", "04", "10", "11"].includes(
            mainInputValue.information.leave_form_no
          ))) &&
        file_pdf && (
        <section>
          <UploadFile
            heading="ไฟล์เอกสารการลา"
            noClick={false}
            onDeleteFile={() => { }}
            file={null}
            fileAttachmentId={1}
            fileAttachmentName={`ไฟล์เอกสารการลา_${dataJson?.main?.first_name || ""}_${dataJson?.main?.last_name}_${moment().format("LL")}`}
            viewButtonWithPath={"CUSTOM"}
            customViewButtonWithPath={URL.createObjectURL(file_pdf)}
            // helperText={item?.id_leave_file}
            onDrop={() => { }}
            onDownloadFile={() => {
              file_pdf && saveAs(file_pdf, `ไฟล์เอกสารการลา_${dataJson?.main?.first_name || ""}_${dataJson?.main?.last_name}_${moment().format("LL")}`)
            }}

            // file={item?.file_path}
            formatText={t("FILE_UPLOAD.FILE_SIZE")}
            hiddenDownloadFile={isCanEdit}
          />
        </section>
      )}


      <section className="w-full my-8 flex flex-wrap justify-center items-center gap-4">
        <ButtonBack
          onClick={() => {
            navigate(routeName.cms.OnlineLeaveSubmission);
          }}
          buttonName={'ย้อนกลับ'}
          btnProps={{
            width: "150px",
          }}
        />

        <>
          {mainInputValue.information.leave_status === "draft" && (
            <>
              {isCanEdit ? (
                <>
                  <ButtonPrimary
                    onClick={() => {
                      handleSubmit(
                        leaveRequestId,
                        mainInputValue,
                        file,
                        dataJson
                      );
                    }}
                    buttonName={t("ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.SAVE")}
                    btnProps={{
                      bg: "#4198E9",
                      width: "150px",
                    }}
                  />
                  <ButtonPrimary
                    onClick={() => {
                      handleSendLeaveRequest();
                    }}
                    buttonName={"ส่งคำร้อง"}
                    btnProps={{
                      width: "150px",
                    }}
                    mode="next"
                  />
                </>
              ) : (
                <>
                  <ButtonPrimary
                    onClick={() => {
                      setIsCanEdit(true);
                    }}
                    buttonName={t(
                      "ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.UPDATE"
                    )}
                    btnProps={{
                      width: "150px",
                    }}
                  />
                </>
              )}
            </>
          )}
        </>

        <>
          {mainInputValue.information.leave_status === "draft" &&
            !isCanEdit && (
              <ButtonDel
                onClick={() => {
                  handleDeleteLeaveRequest();
                }}
                buttonName={t("ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.DELETE")}
                btnProps={{
                  width: "150px",
                }}
              />
            )}
        </>
      </section>
    </div>
  );
};

export default OnlineLeaveSubmissionDetail;
